export default __webpack_public_path__ + "static/broken-down-trend-bar-dark-mode-5c22b0814ad14e3c75e7b349f018b885.png";